const SCOPE_KEY = 'schooldock-auth-scope';

function readUser(value) {
  if (!value) return null;
  if (typeof value === 'object') return value;
  try {
    const parsed = JSON.parse(value);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    return null;
  }
}

export function getUserScope(user, fallbackUsername) {
  const details = readUser(user) || {};
  const principal = details.userId || details.UserId || details.Id || details.StaffId ||
    details.StudentId || details.userName || details.UserName || fallbackUsername;
  if (principal === undefined || principal === null || String(principal).trim() === '') return null;
  const tenant = details.orgId || details.OrgId || details.schoolId || details.SchoolId || '';
  return `user:${encodeURIComponent(String(tenant))}:${encodeURIComponent(String(principal).trim().toLowerCase())}`;
}

export function getCurrentUserScope() {
  if (typeof localStorage === 'undefined') return null;
  return localStorage.getItem(SCOPE_KEY) ||
    getUserScope(localStorage.getItem('####'), localStorage.getItem('###'));
}

export function getOfflineEntityId(entityType, clientId, ownerId = getCurrentUserScope()) {
  return `${entityType}:${ownerId || 'unassigned'}:${clientId}`;
}

export function getOfflineEntityKey(entityType, clientId, ownerId = getCurrentUserScope()) {
  return getOfflineEntityId(entityType, clientId, ownerId);
}

export function setCurrentUserScope(scope) {
  if (typeof localStorage !== 'undefined' && scope) localStorage.setItem(SCOPE_KEY, scope);
}
